import { useDataValue } from 'Simple/Data.js'
import useStableValue from 'Logic/useStableValue.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let search_term = useStableValue(
    useDataValue({
      viewPath: props.viewPath,
      context: 'user_picker',
      path: 'search_term',
    })
  )

  let parent_company_id = useDataValue({
    context: 'global',
    path: 'current_location.parent_company._id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      search_term,
      parent_company_id,
    },
    pause: !parent_company_id || search_term.length < 3,
    requestPolicy: 'cache-and-network',
  }
}
